import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import api from '../../services/api';
import { TotalVeiculo  } from './components';
import i18n from 'translations/langEngine';
import { CommonTranslations } from 'translations/translationKeys'
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';

const useStyles = makeStyles(() => ({
  root: {
    padding: 16, // valor de padding fixo, simplificado sem tema
  }
}));

const Dashboard = () => {
  const classes = useStyles();
  const [totalVeiculo, setTotalVeiculo] = useState(0);

  useEffect(() => {
    const loadDashBoard = async () => {
      try {
        let codempresa = parseInt(sessionStorage.getItem('codEmpresa'), 10);
        const responseVeiculos = await api.get(`/dashboard/front/totalveiculo/${codempresa}` );
        console.log('Total de Pax em Trânsito: ' + JSON.stringify(responseVeiculos.data));
        setTotalVeiculo(responseVeiculos.data[0].totalveiculo);

      } catch (error) {
        console.error(error);
      }
    };

    loadDashBoard();
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={4}>
        <Grid item lg={3} sm={6} xl={3} xs={12}>
          <TotalVeiculo totalVeiculo={totalVeiculo} />
        </Grid>
      </Grid>
    </div>
  );
};

export default Dashboard;
